export enum GamePhase {
  Walking = 'WALKING',
  Fighting = 'FIGHTING',
  Dead = 'DEAD',
  Resting = 'RESTING',
  InTown = 'IN_TOWN',
}

export enum BuffType {
  Rush = 'rush',
  Rage = 'rage',
  Shield = 'shield',
  Luck = 'luck',
  Resurrection = 'resurrection',
  Heal = 'heal',
  PowerPotion = 'power_potion',
  WarCry = 'war_cry',
}

export enum DebuffType {
  Poison = 'poison',
  Freeze = 'freeze',
  Burn = 'burn',
  Stun = 'stun',
  Slow = 'slow',
  Weaken = 'weaken',
  IceSlow = 'ice_slow',
}

export enum Rarity {
  Common = 'common',
  Uncommon = 'uncommon',
  Rare = 'rare',
  Epic = 'epic',
  Legendary = 'legendary',
}

export enum EnemyType {
  Wolf = 'wolf',
  Boar = 'boar',
  Zombie = 'zombie',
  Spider = 'spider',
  Orc = 'orc',
  SkeletonArcher = 'skeleton_archer',
  BattleLizard = 'battle_lizard',
  FireDemon = 'fire_demon',
  IceGuardian = 'ice_guardian',
  SkeletonKing = 'skeleton_king',
  WaterElement = 'water_element',
  ForestWarden = 'forest_warden',
  LightningTitan = 'lightning_titan',
}

export enum WeaponType {
  Daggers = 'daggers',
  Sword = 'sword',
  Axe = 'axe',
}

export enum ArmorType {
  Light = 'light',
  Medium = 'medium',
  Heavy = 'heavy',
}

export enum AnimationState {
  Idle = 'idle',
  Walk = 'walk',
  Attack = 'attack',
  Hit = 'hit',
  Death = 'death',
  BuffActivation = 'buff_activation',
}
